import { useTranslation } from "react-i18next";
import {
  AsyncCallArgs,
  CardSpg,
  getFieldError,
  GridContainer,
  GridItem,
  handleFormSubmission,
  handleSubmitValidationFail,
  shouldShowFieldError,
  SubmitFormButton,
  useAsyncCall,
  useReactHookForm,
  useScroll,
  ValidationErrors,
} from "@duosoftbg/nacid-components";
import React from "react";
import { FormProvider } from "react-hook-form";
import { UserRegistrationDetails } from "../../../../../types/userTypes";
import { userRegistrationInitialValues } from "../../../../../init/userRegistrationInitialValues";
import { createRegistrationValidationSchema } from "../../../../../yup/schema/registration/registrationValidationSchema";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { userRegistration } from "../../../../../axios/api/services";
import PageWrapper from "../../../common/layout/PageWrapper";
import { Alert, CardContent, Typography } from "@mui/material";
import AccountFormSection from "../common/account/AccountFormSection";
import PersonFormSection from "../common/person/PersonFormSection";
import RepresentativeFormSection from "../common/representative/RepresentativeFormSection";
import ContactAddressFormSection from "../common/address/ContactAddressFormSection";
import ResultReceiveFormSection from "../common/resultReceive/ResultReceiveFormSection";
import ReceiverAddressFormSection from "../common/address/ReceiverAddressFormSection";

const RegistrationForm = ({ setSuccessRegistration, setUserDetails }) => {
  const { t } = useTranslation();
  const { scrollToTop } = useScroll();
  const { asyncCall } = useAsyncCall();

  const { methods } = useReactHookForm<UserRegistrationDetails>({
    defaultValues: userRegistrationInitialValues,
    validationSchema: createRegistrationValidationSchema,
  });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onSubmit = async (values) => {
    const token = await executeRecaptcha("PortalRegistrationSubmit");
    const asyncRegistration: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: userRegistration(values, token),
      reactHooksForm: { methods },
      onSuccess: () => {
        setSuccessRegistration(true);
        setUserDetails({ username: values.username, email: values.email });
      },
      onValidationError: () => {
        scrollToTop(true);
      },
    };
    asyncCall(asyncRegistration);
  };

  const onYupValidationFail = () => {
    scrollToTop(true);
    handleSubmitValidationFail(methods.formState, t, {});
  };

  return (
    <PageWrapper title={t("t.page.registration")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          <FormProvider {...methods}>
            <form
              onSubmit={handleFormSubmission({
                methods,
                onSubmitFn: onSubmit,
                onValidationFail: onYupValidationFail,
                t,
              })}
            >
              {shouldShowFieldError("captchaToken", methods.formState, methods.getFieldState) ? (
                <Alert severity={"error"}>{getFieldError("captchaToken", methods.getFieldState)}</Alert>
              ) : null}

              <ValidationErrors />
              <AccountFormSection />
              <PersonFormSection />
              <RepresentativeFormSection />
              <ContactAddressFormSection />
              <ResultReceiveFormSection />
              <ReceiverAddressFormSection />

              <GridContainer>
                <GridItem sm={12} md={12}>
                  <Typography align={"right"}>
                    <SubmitFormButton label={"l.btn.register"} />
                  </Typography>
                </GridItem>
              </GridContainer>
            </form>
          </FormProvider>
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};
export default RegistrationForm;
